import { render } from "./DefaultLayout.vue?vue&type=template&id=4e8d6ab9"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=4e8d6ab9&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__